import React from "react"
import axios from 'axios'
import { MDCLinearProgress } from '@material/linear-progress';
import $ from "jquery";
import { MDCDataTable } from '@material/data-table';
import { MDCTextField } from '@material/textfield';
import { MDCSnackbar } from '@material/snackbar';
import { MDCTabBar } from '@material/tab-bar';

function roundPlus(number) { if (isNaN(number)) return false; var m = Math.pow(10, 2); return Math.round(number * m) / m; }

function timestampToHuman(timestamp) {
    var d = new Date(timestamp)
    return `${insertPrefixZero(d.getDate())}.${insertPrefixZero(d.getMonth() + 1)}.${insertPrefixZero(d.getFullYear())} ${insertPrefixZero(d.getHours())}:${insertPrefixZero(d.getMinutes())}`
}

function networkToHuman(network) {
    if (network == "telegram") return "Telegram"
    if (network == "instagram") return "Instagram"
    if (network == "twitter") return "Twitter"
    if (network == "vk") return "ВКонтакте"
    if (network == "facebook") return "Facebook"
    if (network == "tiktok") return "TikTok"
    if (network == "youtube") return "YouTube"
}

function iconByNetwork(network) {
    if (network == "telegram") return "fa-telegram-plane"
    if (network == "instagram") return "fa-instagram"
    if (network == "twitter") return "fa-twitter"
    if (network == "vk") return "fa-vk"
    if (network == "facebook") return "fa-facebook"
    if (network == "tiktok") return "fab fa-tiktok"
    if (network == "youtube") return "fab fa-youtube"
}

function iconByType(type) {
    if (type == "subscribers") return "fa-user"
    if (type == "views" || type == "retweets") return "fa-eye"
    if (type == "members" || type == "friends") return "fa-user-friends"
    if (type == "reactions") return "fa-thumbs-up"
    if (type == "users") return "fa-robot"
    if (type == "likes") return "fa-heart"
    if (type == "followers") return "fa-users"
    if (type == "saves") return "fa-bookmark"
}

function typeToHuman(type) {
    if (type == "subscribers") return "Подписчики"
    if (type == "views") return "Просмотры"
    if(type == "retweets") return "Ретвиты"
    if (type == "members") return "Участники"
    if(type == "friends")  return "Друзья"
    if (type == "reactions") return "Реакции"
    if (type == "users") return "Пользователи"
    if (type == "likes") return "Лайки"
    if (type == "followers") return "Подписчики"
    if (type == "saves") return "Сохранения"
}


function insertPrefixZero(num) {
    return num < 10 ? `0${num}` : num
}

function statusToHuman(status){
    if(status=="created") return 'создан'
     if(status=="pending") return 'ожидает'
     if(status=="performed") return 'исполняется'
     if(status=="completed") return 'завершён'
    }

var snackbar

class OrdersListBox extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadServices()
    }

    render(props) {

        const { error, isLoaded, items } = this.props.state;
        if (error) {
            return <div>Ошибка: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Загрузка...</div>;
        } else {
            return (
                <div className="ibox" style={{ flex: "0 0 1000px", minWidth: "100%", margin: "24px 24px 24px 0", overflowX: "auto" }}>
                    <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Заказы</h3>  
                    <div className="ibox_content" style={{ padding: "0" }}>
                        <div className="mdc-data-table" style={{ width: "100%" }}>
                            <table className="mdc-data-table__table" aria-label="Dessert calories">
                                <thead>
                                    <tr className="mdc-data-table__header-row">
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>UID</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>OID</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>SID</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Соц. сеть</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Сервис</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Ссылка</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Количество</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Цена</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Сумма</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Статус</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Осталось</b></th>
                                        <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Дата и время</b></th>
                                    </tr>
                                </thead>
                                <tbody className="mdc-data-table__content" id="historyTable">
                                    {items.map(item => (<tr className="mdc-data-table__row">
                                            <td className="mdc-data-table__cell"> {item.uid}</td>
                                            <td className="mdc-data-table__cell"> {item.n}</td>
                                            <td className="mdc-data-table__cell"> {item.service.sid}</td>
                                            <td className="mdc-data-table__cell"> <i className={"fab " + iconByNetwork(item.service.network)} aria-hidden="true" style={{ marginRight: "6px", fontSize: "1rem" }}></i>{networkToHuman(item.service.network)}</td>
                                            <td className="mdc-data-table__cell" > <i className={"fas " + iconByType(item.service.type)} aria-hidden="true" style={{ marginRight: "6px", fontSize: "1rem" }}></i>{typeToHuman(item.service.type)}</td>
                                            <td className="mdc-data-table__cell" style={{maxWidth: "166px", overflowX: "hidden"}}> {item.link}</td>
                                            <td className="mdc-data-table__cell"> {item.amount}</td>
                                            <td className="mdc-data-table__cell"> {item.price}$</td>
                                            <td className="mdc-data-table__cell"> {item.total}$</td>
                                            <td className="mdc-data-table__cell"> {statusToHuman(item.status)}</td>
                                            <td className="mdc-data-table__cell"> {item.remains}</td>
                                            <td className="mdc-data-table__cell"> {timestampToHuman(item.timestamp)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            );
        }


    }
}

class OrdersTab extends React.Component {
    constructor(props) {
        super(props);
        this.loadServices = this.loadServices.bind(this)

        this.state = {
            error: null,
            isLoaded: false,
            items: []
        }

    }

    componentDidMount() {

    }

    loadServices() {
        axios.get("https://nakrutkatop.com:443/api/admin/orders", { withCredentials: true })
            .then(res => {
                document.getElementById("mainContent").style.opacity = 1
                this.setState({
                    isLoaded: true,
                    items: res.data.orders
                }, () => { new MDCDataTable(document.querySelector('.mdc-data-table')); })
            })
    }

    render(props) {
        return <div id="mainContent" style={{ opacity: "0", transition: "1.5s opacity" }}>
            <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>
                <OrdersListBox loadServices={this.loadServices} state={this.state} />
            </div>
        </div>
    }
}

export default OrdersTab